/* global wp_theme */

class Main {
    constructor() {
        this.DOM = {
            body: document.body
        };

        this.setEventListeners();
        this.setDevAdminLinks();
        this.logCredits();
        this.startIntro();

        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('setCursorElements'));
        }, 250);

        // Give tw20-plugin a moment to initialize before deciding whether to enable the fallback shortcut
        setTimeout(() => {
            if (!window.tw20Main) {
                this.setAdminShortcut();
            }
        }, 500);
    }

    startIntro() {
        this.DOM.body.classList.remove('preload');
        this.DOM.body.classList.add('start-intro');
    }

    setEventListeners() {}

    setDevAdminLinks() {
        setTimeout(() => {
            const adminbarLinks = document.querySelectorAll('#wpadminbar a.ab-item');
            adminbarLinks.forEach((element) => {
                element.href = element.href.replace(':8000', '');
            });
        }, 100);
    }

    setAdminShortcut() {
        // Edit page shortcut: Press "A" twice within 3 seconds to go to the admin edit page
        let waitingForSecond = false;
        document.addEventListener('keydown', (e) => {
            if (e.code !== 'KeyA') return;

            const tag = document.activeElement?.tagName;
            if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || document.activeElement?.isContentEditable)
                return;

            if (waitingForSecond) {
                const adminEditLink = document.querySelector('#wp-admin-bar-edit a')?.href;
                window.location.href =
                    adminEditLink ?? wp_theme.login_url + '?redirect_to=' + encodeURIComponent(window.location.href);
                return;
            }

            waitingForSecond = true;
            setTimeout(() => {
                waitingForSecond = false;
            }, 3000);
        });
    }

    logCredits() {
        if (window.console && console.log) {
            console.log('Made by www.twelvetwentystudio.com');
        }
    }
}
new Main();
